export default {
      id: "PDF-icon-usage",
      viewBox: "0 0 23 24",
      url: __webpack_public_path__ + "sprite.svg#PDF-icon",
      toString: function () {
        return this.url;
      }
    }